import { createBrowserHistory } from 'history';
//const createHistory = history.createBrowserHistory;
//import createHistory from 'history/createBrowserHistory'

export default createBrowserHistory({
  forceRefresh: true
})